/**
 * @typedef {Object} VehicleTypes
 * @property {number} CAR - Car type with value 1
 * @property {number} CARAVAN - Caravan type with value 3
 * @property {number} MOTORBIKE - Motorbike type with value 5
 * @property {number} VAN - Van type with value 9
 */
 
 /**
 * @type {VehicleTypes}
 */
 const VEHICLE_TYPE_ENUM = {
    UNKNOWN: 0,
    CAR: 1,
    CARAVAN: 3,
    MOTORBIKE: 5,
    VAN: 9,
};

module.exports = {
    VEHICLE_TYPE_ENUM
};